import BaseAPI from "../api";

const path: string = "/advisor-request";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};

export class advisorRequestApi extends BaseAPI {
  static getAllAdvisorRequest(query?: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static getAdvisorRequestByUserLogin(): Promise<any> {
    return this.api.get(`${path}/find-one`);
  }

  static getSingleAdvisorRequestById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/find-one/data`);
  }

  static createAdvisorRequest(body: FormData): Promise<any> {
    return this.api.post(`${path}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static updateAdvisorRequest(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteAdvisorRequest(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static updateStatusAdvisorRequest(
    id: number,
    stutus: string,
    comment?: string
  ): Promise<any> {
    return this.api.patch(`${path}/${id}/status-advisor`, {
      status_advisor_approve: stutus,
      advisor_refuse: comment,
    });
  }

  static updateStatusAdvisorRequestAll(
    id: number,
    stutus: string,
    comment?: string
  ): Promise<any> {
    return this.api.patch(`${path}/${id}/status-advisor`, {
      status_advisor_approve: stutus,
      advisor_refuse: comment,
    });
  }

  static getSingleAdvisorTransferById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/find-one/changed-advisor`);
  }

  static transferAdvisorRequest(
    id_advisor_request: number,
    new_advisor_id: number,
    comment: string
  ): Promise<any> {
    return this.api.post(`${path}/transfer-advisor`, {
      id_advisor_request: id_advisor_request,
      new_advisor_id: new_advisor_id,
      advisor_reason: comment,
    });
  }

  static downloadFileRequest(id: number): Promise<any> {
    return this.api.get(
      `${path}/advisor-student-file/${id}/download?type=pdf`,
      {
        responseType: "arraybuffer",
      }
    );
  }

  static getHistoyAdvisorRequest(query?: listType): Promise<any> {
    return this.api.get(`${path}/history-advisor-request/list`, {
      params: { ...query },
    });
  }
}
